var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement-box clearfix"},[_c('div',{directives:[{name:"track",rawName:"v-track",value:({
      type: 'click',
      name: `${_vm.$route.params.type || 'phone'}.${
        _vm.$route.params.step || 'account'
      }.agreement`,
    }),expression:"{\n      type: 'click',\n      name: `${$route.params.type || 'phone'}.${\n        $route.params.step || 'account'\n      }.agreement`,\n    }"}],staticClass:"agreement-checkbox",class:[_vm.value ? 'agreement-checkbox-active' : 'agreement-checkbox-init'],on:{"click":_vm.handleClick}},[(_vm.value)?_c('div',{staticClass:"agreement-checkbox-right"}):_vm._e()]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement-text"},[_c('span',[_vm._v("本人知晓并同意，友邦人寿收集本人的[姓名、联系方式、教育信息]用于未来招募实习目的与您联系\n    ")])])
}]

export { render, staticRenderFns }